import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'

export function useTeams() {
    const [teams, setTeams] = useState<string[]>([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        fetchTeams()
    }, [])

    async function fetchTeams() {
        try {
            setLoading(true)

            // Fetch all job_family values in batches (Supabase has 1000-row default limit)
            let allJobFamilies: { job_family: string | null }[] = []
            let from = 0
            const batchSize = 1000
            let hasMore = true

            while (hasMore) {
                const { data, error: fetchError } = await supabase
                    .from('published_jobs')
                    .select('job_family')
                    .not('job_family', 'is', null)
                    .range(from, from + batchSize - 1)

                if (fetchError) throw fetchError

                const batch = data || []
                allJobFamilies = [...allJobFamilies, ...batch]

                // If we got fewer than batchSize rows, we've reached the end
                hasMore = batch.length === batchSize
                from += batchSize
            }

            // Extract unique teams
            const teamSet = new Set<string>()

            allJobFamilies.forEach(job => {
                if (job.job_family) {
                    teamSet.add(job.job_family)
                }
            })

            // Convert to sorted array
            const sortedTeams = Array.from(teamSet).sort()
            setTeams(sortedTeams)
        } catch (err) {
            setError(err instanceof Error ? err.message : 'Failed to fetch teams')
            console.error('Error fetching teams:', err)
        } finally {
            setLoading(false)
        }
    }

    return { teams, loading, error }
}
